import { render, staticRenderFns } from "./OpenDoorIcon.vue?vue&type=template&id=ecc5ca32"
import script from "./OpenDoorIcon.vue?vue&type=script&lang=js"
export * from "./OpenDoorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports